var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#E3DBFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 29.625H48.5V39.625C48.5 46.2524 43.1274 51.625 36.5 51.625C29.8726 51.625 24.5 46.2524 24.5 39.625V29.625Z",
    fill: "#927BF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 37.625L48.5 29.625L51.5 29.625C53.7091 29.625 55.5 31.4159 55.5 33.625V33.625C55.5 35.8341 53.7091 37.625 51.5 37.625L48.5 37.625Z",
    stroke: "#927BF7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 51.625H49",
    stroke: "#927BF7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4984 29.625C30.9947 26.4688 33.9961 26.4062 33.9961 23.4062M39.4984 29.625C38.9984 25.875 41.9984 26.375 41.9984 23.375",
    stroke: "#927BF7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5039 36.375L30.6616 36.2568C31.6976 35.4797 33.1591 35.6409 34.0009 36.625V36.625",
    stroke: "#E3DBFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 36.375L39.6577 36.2568C40.6937 35.4797 42.1551 35.6409 42.997 36.625V36.625",
    stroke: "#E3DBFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 43.375V43.375C34.5085 45.4822 37.5371 45.7568 39.4 43.9552L40 43.375",
    stroke: "#E3DBFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.00814cf625210343333abae2d526b907.svg";
export { ForwardRef as ReactComponent };